import { IApplicationState } from '../../types/redux';

export function selectMortgageBanks(state: IApplicationState) {
  return state.mortgage.analyticsData.banks;
}
